var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24919 0.633646C2.42821 0.633646 0.952006 2.10985 0.952006 3.93083V22.0692C0.952006 23.8902 2.4282 25.3664 4.24919 25.3664H22.0693C23.8903 25.3664 25.3665 23.8902 25.3665 22.0692V3.93083C25.3665 2.10985 23.8903 0.633646 22.0693 0.633646H4.24919Z",
    fill: "#FAFAFA",
    stroke: "#D0D8DC",
    strokeWidth: 0.732708
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 10.0004C12.6478 10.0287 12.2946 9.96507 11.9747 9.81567C7.47529 7.1595 6.6517 11.7016 7.10651 14.5018C7.61601 17.6161 8.93642 20.243 10.757 20.4857C10.9384 20.5035 11.1209 20.4658 11.2805 20.3777L12.5582 19.7275C12.694 19.6578 12.8444 19.6214 12.997 19.6214C13.1496 19.6214 13.3001 19.6578 13.4358 19.7275L14.7136 20.3777C14.8731 20.4658 15.0557 20.5035 15.2371 20.4857C17.0576 20.243 18.3781 17.6181 18.8876 14.5018C19.135 12.9953 19.0116 10.9854 18.144 9.86102",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3677 8.05054C16.894 8.49899 16.3014 8.80178 15.6605 8.92281C15.5511 8.95903 15.4338 8.96385 15.3218 8.93675C15.2098 8.90964 15.1077 8.85168 15.027 8.76946C14.9463 8.68724 14.8903 8.58404 14.8653 8.47158C14.8403 8.35912 14.8473 8.2419 14.8856 8.13323C15.0017 7.48449 15.2985 6.88166 15.7418 6.39402C16.2151 5.94489 16.8078 5.6418 17.449 5.52107C17.5584 5.48514 17.6756 5.48051 17.7874 5.50771C17.8993 5.53492 18.0013 5.59287 18.0819 5.67502C18.1625 5.75717 18.2185 5.86023 18.2436 5.97256C18.2687 6.08489 18.2619 6.202 18.2239 6.31066C18.1075 6.95951 17.8108 7.56248 17.3677 8.05054Z",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5V10.0008",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBoxed);
export default __webpack_public_path__ + "static/media/AppleBoxed.b4b8e124f8ef7d678103927716fa6a50.svg";
export { ForwardRef as ReactComponent };